<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useImage } from "@/hooks";
import { computed } from "vue";

const props = defineProps<{
  src?: string;
}>();

const { imageUrl } = useImage(computed(() => props.src));
</script>
<template>
  <PreviewableImage class="mp-static-image" :src="imageUrl" v-bind="$attrs" />
</template>
